import { subDays } from 'date-fns/esm'
import React from 'react'
import * as Texts from '../../../../../intl'

import { form } from '../../../formState'
import { SimulationDatesPicker } from '../primitives/SimulationDatesPicker'
import type {
  CalendarRange,
  SimulationDate,
  SimulationDateType,
} from '../primitives/SimulationDatesPicker/typings'
import { PublicProps } from './typings'

const SimulationDatesPickerField: React.FC<PublicProps> = props => {
  const { wrappedInputProps } = props

  const {
    field,
    formApi: { change: onChange },
  } = form.useFormField('simulationDate')

  form.useAddFieldValidation<'simulationDate'>('simulationDate', (field, _formApi) => {
    const value = field.value || {}

    if (value.type === 'fromArchived' && !value.date) {
      return Texts.getSimulationValidationDateNotSet()
    }

    if (value.type === 'fromOperations') {
      if (!value.dates.min || !value.dates.max) return Texts.getSimulationValidationDateNotSet()
    }

    return undefined
  })

  const handleOnChange = (calendarRange: CalendarRange, type: SimulationDateType) => {
    let simulationDate: SimulationDate = {
      type: 'fromScratch',
    }

    switch (type) {
      case 'fromScratch':
        break
      case 'fromOperations':
        simulationDate = {
          type,
          dates: calendarRange,
        }
        break
      case 'fromArchived':
        simulationDate = {
          type,
          date: calendarRange.min,
        }
    }

    onChange('simulationDate', simulationDate)
  }

  const handleOnChangeType = (type: SimulationDateType) => {
    const {
      wrappedInputProps: { today, firstDayNotArchived },
    } = props

    if (field.value.type === type) {
      return null
    }

    let simulationDate: SimulationDate = {
      type: 'fromScratch',
    }

    switch (type) {
      case 'fromScratch':
        break

      case 'fromOperations':
        simulationDate = {
          type: 'fromOperations',
          dates: { min: today, max: today },
        }
        break
      case 'fromArchived':
        simulationDate = {
          type: 'fromArchived',
          date: subDays(firstDayNotArchived, 1),
        }
        break
    }

    onChange('simulationDate', simulationDate)
  }

  return (
    <SimulationDatesPicker
      {...wrappedInputProps}
      onChangeType={handleOnChangeType}
      onChange={handleOnChange}
      value={field.value}
    />
  )
}

export default SimulationDatesPickerField
